import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'it', 'he'],
    ns: ['common'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'cookie', 'navigator'],
      caches: ['localStorage', 'cookie'],
    },
  });

// Handle RTL for Hebrew, and keep the document's own language declaration truthful.
// `<html lang>` is what screen readers pick a voice from and what the browser offers to translate against;
// it was hardcoded `en` in index.html and never updated, so every non-English user was served a document
// that claimed to be English. body.dir was already handled — lang was the half that was missing.
i18n.on('languageChanged', (lng) => {
  document.body.dir = i18n.dir(lng);
  document.documentElement.lang = lng;
});

export default i18n;
